import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import EventsLeagues from "../events/eventsLeagues";
import EventsPerLeagues from "../events/eventsPerLeague";
import _ from "lodash";

function Events() {
  const [eventsLeagues, setEventsLeagues] = useState([]);
  const [idLeague, setIdLeague] = React.useState(1);

  const [loading, setLoading] = useState(false);
  const requestEvents = useCallback(
    (idLeagueValue = idLeague) => {
      setLoading(true);
      let url =
        process.env.REACT_APP_API2_URL +
        "/Events/GetEventsByLeague2?idLeague=" +
        idLeagueValue;
      axios({
        method: "get",
        url: url,
      })
        .then((response) => {
          let events = _.groupBy(response.data, "idEvent");
          events = _.map(events, (eventDetails) => _.head(eventDetails));
          events = _.orderBy(events, ["eventOrder"], ["asc"]);
          setEventsLeagues(events);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [idLeague]
  );

  useEffect(() => {
    requestEvents();
  }, []);

  useEffect(() => {
    requestEvents();
  }, [idLeague]);

  const changeLeagueID = useCallback((value) => {
    setIdLeague(value);
  }, []);

  return (
    <React.Fragment>
      <div className="flex flex-row items-start justify-center gap-4">
        <EventsLeagues ChangeLeagueID={changeLeagueID} />
        <EventsPerLeagues
          className={`${loading ? "hidden" : ""}`}
          IdLeague={idLeague}
          EventsLeagues={eventsLeagues}
          RequestEvents={requestEvents}
        />
      </div>
    </React.Fragment>
  );
}

export default Events;
